/**
 * Mobile ETF Screener Page
 * 
 * Uses the existing ETFBookBrowser component since it's already responsive
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileLayout from './MobileLayout';
import ETFBookBrowser from '../../components/ETFBook/ETFBookBrowser';
import apiHelper from '../../utils/apiHelper';

const { FILE_NAMES } = require('../../utils/constants');

function MobileETFBook() {
    const navigate = useNavigate();
    const [etfData, setEtfData] = useState([]);
    const [etfBookGraphData, setEtfBookGraphData] = useState([]);
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Load ETF data - following the same pattern as desktop ETFBook.js
    useEffect(() => {
        const fetchData = async () => {
            try {
                const etfBookResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.ETF_BOOK);
                const etfBookData = etfBookResult.fileContent;  
         
                const etfBookGraphResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.ETF_BOOK_GRAPH);
                const etfBookGraphData = etfBookGraphResult.fileContent;

                const settingsResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.SETTINGS);
                const settingsData = settingsResult.fileContent;

                setEtfData(etfBookData);
                setEtfBookGraphData(etfBookGraphData);
                setSettings(settingsData);

                setLoading(false);
            } catch (err) {
                setLoading(false);
                console.error('Error loading ETF data:', err);
            }
        };
        fetchData();
    }, []);
    
    return (
        <MobileLayout 
            title="ETF Screener" 
            showBackButton={true} 
            onBackClick={() => navigate('/mobile')}
            backButtonIcon="home"
        >
            <div id='etfBookPage'>
                <ETFBookBrowser 
                    etfData={etfData}
                    graphData={etfBookGraphData}
                    loading={loading}
                    mobileMode={true}
                    settings={settings}
                />
            </div>
        </MobileLayout>
    );
}

export default MobileETFBook; 